/**
 * Custom Availability filter (In stock / Out of stock / Coming soon)
 *
 * Three checkboxes, none selected by default (= all products shown).
 * Selected options combine (union). The options never overlap:
 *   - In stock     = product is available (any custom.coming_soon value)
 *   - Out of stock = not available AND custom.coming_soon is false or unset
 *   - Coming soon  = not available AND custom.coming_soon is exactly true
 *
 * Shopify's native filter.v.availability parameter still narrows results
 * on the server (1 = in stock, 0 = out of stock). The coming_soon split is
 * applied here against each card's real metafield value, so an unset
 * metafield is never assumed to equal false.
 *
 * A hidden `avail_state` field (comma separated) rides in the same filter
 * form so it persists through the theme's AJAX filtering / history flow.
 * Pre-rendered hidden native inputs are toggled via `disabled` (no DOM
 * insertions), so syncing never triggers its own observer.
 */
(function () {
  var PRODUCT_GRID_ID = 'ProductGridContainer';
  var FILTERS_ROOT_ID = 'main-collection-filters';
  var HIDE_CLASS = 'avail-filter-hidden';
  var STATES = ['in_stock', 'out_of_stock', 'coming_soon'];
  var NATIVE_PARAM = 'filter.v.availability';

  function injectStyle() {
    if (document.getElementById('availability-filter-style')) return;
    var style = document.createElement('style');
    style.id = 'availability-filter-style';
    style.textContent = '.' + HIDE_CLASS + '{display:none!important;}';
    document.head.appendChild(style);
  }

  function parseStates(csv) {
    if (!csv) return [];
    return STATES.filter(function (s) { return csv.split(',').indexOf(s) > -1; });
  }

  function getAvailStates() {
    var params = new URLSearchParams(window.location.search);
    var natives = params.getAll(NATIVE_PARAM).join(',').split(',').filter(Boolean);
    if (!natives.length) return [];

    var fromParam = parseStates(params.get('avail_state'));
    if (fromParam.length) return fromParam;

    // Direct/shared link with only the native parameter.
    var out = [];
    if (natives.indexOf('1') > -1) out.push('in_stock');
    if (natives.indexOf('0') > -1) out.push('out_of_stock');
    return out;
  }

  function cardMatches(card, states) {
    var avail = card.getAttribute('data-product-available');
    var isAvail = avail === 'true' ? true : (avail === 'false' ? false : null);
    var comingSoon = card.getAttribute('data-coming-soon') === 'true';

    return states.some(function (state) {
      if (state === 'in_stock') return isAvail !== false;
      if (state === 'out_of_stock') return isAvail !== true && !comingSoon;
      if (state === 'coming_soon') return isAvail !== true && comingSoon;
      return false;
    });
  }

  function applyProductFilter() {
    var states = getAvailStates();
    var container = document.getElementById(PRODUCT_GRID_ID);
    if (!container) return;

    container.querySelectorAll('[data-collection-product]').forEach(function (card) {
      var hide = states.length > 0 && !cardMatches(card, states);
      var wrapper = card.closest('[data-collection-item]') || card;
      wrapper.classList.toggle(HIDE_CLASS, hide);
    });
  }

  function writeBlockState(block, states) {
    var hiddenField = block.querySelector('[data-availability-state-field]');
    if (hiddenField) hiddenField.value = states.join(',');

    var needIn = states.indexOf('in_stock') > -1;
    var needOut = states.indexOf('out_of_stock') > -1 || states.indexOf('coming_soon') > -1;

    block.querySelectorAll('[data-availability-native]').forEach(function (input) {
      var wanted = input.value === '1' ? needIn : needOut;
      input.disabled = !wanted;
    });

    block.querySelectorAll('[data-availability-option]').forEach(function (box) {
      box.checked = states.indexOf(box.getAttribute('data-availability-option')) > -1;
    });

    var reset = block.querySelector('[data-availability-reset]');
    if (reset) {
      var params = new URLSearchParams(window.location.search);
      params.delete(NATIVE_PARAM);
      params.delete('avail_state');
      var qs = params.toString();
      reset.setAttribute('href', window.location.pathname + (qs ? '?' + qs : ''));
    }
  }

  function syncAvailabilityUI() {
    var states = getAvailStates();
    document.querySelectorAll('[data-availability-filter]').forEach(function (block) {
      writeBlockState(block, states);
    });
  }

  function onAvailabilityOptionChange(event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-availability-option]')) return;

    var block = target.closest('[data-availability-filter]');
    if (!block) return;

    var states = [];
    block.querySelectorAll('[data-availability-option]').forEach(function (box) {
      if (box.checked) states.push(box.getAttribute('data-availability-option'));
    });
    writeBlockState(block, STATES.filter(function (s) { return states.indexOf(s) > -1; }));
  }

  function init() {
    injectStyle();
    syncAvailabilityUI();
    applyProductFilter();

    document.addEventListener('change', onAvailabilityOptionChange);

    var productGrid = document.getElementById(PRODUCT_GRID_ID);
    if (productGrid) {
      new MutationObserver(applyProductFilter).observe(productGrid, { childList: true, subtree: true });
    }

    var filtersRoot = document.getElementById(FILTERS_ROOT_ID);
    if (filtersRoot) {
      new MutationObserver(syncAvailabilityUI).observe(filtersRoot, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
